import React from 'react';
import dynamic from 'next/dynamic';
import { isClientSide } from 'services/utils';
import { MapMarker } from 'types/map';

const Map = dynamic(() => import('./cart-map/Map'), {
    ssr: false,
});

interface ICartMap {
    markers: MapMarker<any>[];
    distance?: string;
    setDistance?: (distance: string) => void;
}

const CartMap = ({ markers, distance, setDistance }: ICartMap) => {
    return <>{isClientSide() && <Map markers={markers} distance={distance} setDistance={setDistance} />}</>;
};

export default CartMap;
